module.exports = __webpack_public_path__ + "static/cv-8aff131d1c35c079e6b8c58f103a7c10.pdf";